import { TUserData } from "../types";
import { api } from "@nbcom/api";

/**
 * Getting user data by access token
 */
export const fetchUserData = async (): Promise<TUserData | void> =>
  await api.get<TUserData>(
    {
      url: `api/user-data-proxy`,
      apiUrl: ``,
      credentials: `include`,
    },
    true,
  );
